import axios from "axios";
import { LoginContext } from "contexts/LoginContext";
import { useContext } from "react";
import { useQuery } from "react-query";
import {configUrl} from "config.js";

export default function useGetAssignedCoursesCount() {
  const { user } = useContext(LoginContext);

  return useQuery("assignedCoursesCount", async () => {
    let response = await axios.get(
      `${configUrl.AssessmentServer}/api/Courses/assignedCoursesCount/${user}`
    );
  
    return response.data;
  });
}
